export default "/img/PE.49cf701431fda7e6243aa0b757fbc70c.png";